import { signInFormReducer } from '@zocdoc-frontend-common/components-sign-in-form';
import { phoneVerificationPageReducer } from '@zocdoc-frontend-common/components-phoneverification/Reducer';
import { phoneReducer } from '@zocdoc-frontend-common/components-phoneverification/PhoneReducer';
import { procedureDropdownReducer } from '@zocdoc-frontend-common/components-proceduredropdown';
import {
    timesgridReducer,
    TIMESGRID_ROOT_KEY,
} from '@zocdoc-frontend-common/components-timesgrid';

import { bookingContainerReducer } from '../components/BookingContainer/BookingContainerReducer';
import { createAccountFormReducer } from '../components/CreateAccountForm';
import { newSubpatientFormReducer } from '../components/NewSubpatientForm/NewSubpatientFormReducer';
import { appointmentInfoPageReducer } from '../pages/AppointmentInfo/AppointmentInfoPageReducer';
import { appointmentDetailsReducer } from '../pages/AppointmentDetails/AppointmentDetailsReducer';
import appointmentRequirementsReducer from '../components/AppointmentRequirements/AppointmentRequirementsReducer';
import { doctorCardReducer } from '../components/DoctorCard/doctorCardReducer';
import { patientReducer } from '../reducers/PatientReducer';
import { wellGuideReducer } from '../reducers/WellGuideReducer';
import { schedulingReducer } from '../reducers/SchedulingReducer';
import { initialBookingReducer } from '../reducers/InitialBookingReducer';
import {
    INSURANCE_STATE_KEY,
    insuranceReducer,
} from '@zocdoc-frontend-common/components-insuranceform';
import { phoneEntryPageReducer } from '../pages/PhoneEntry/PhoneEntryPageReducer';
import { reviewAndBookPageReducer } from '../pages/ReviewAndBook/reducer';
import * as Keys from '../constants';
import * as AppointmentRequirementsKeys from '../components/AppointmentRequirements/constants';
import { signupReducer } from './SignUpReducer';
import { surveyReducer } from './SurveyReducer';
import resetPassword from '../../accounts/resetPassword/state/reducer';

export default {
    [INSURANCE_STATE_KEY]: insuranceReducer,
    procedureDropdown: procedureDropdownReducer,
    [AppointmentRequirementsKeys.ROOT_STATE_KEY]: appointmentRequirementsReducer,
    [Keys.BOOKING_CONTAINER_ROOT_KEY]: bookingContainerReducer,
    [Keys.SIGN_IN_FORM_ROOT_KEY]: signInFormReducer,
    [Keys.CREATE_ACCOUNT_FORM_ROOT_KEY]: createAccountFormReducer,
    [Keys.NEW_SUBPATIENT_FORM_ROOT_KEY]: newSubpatientFormReducer,
    [Keys.PHONE_VERIFICATION_ROOT_KEY]: phoneVerificationPageReducer,
    [Keys.APPOINTMENT_INFO_ROOT_KEY]: appointmentInfoPageReducer,
    [Keys.APPOINTMENT_DETAILS_ROOT_KEY]: appointmentDetailsReducer,
    [Keys.PATIENT_ROOT_KEY]: patientReducer,
    [Keys.PHONE_ROOT_KEY]: phoneReducer,
    [Keys.SCHEDULING_ROOT_KEY]: schedulingReducer,
    [Keys.DOCTOR_CARD_ROOT_KEY]: doctorCardReducer,
    [Keys.INITIAL_BOOKING_ROOT_KEY]: initialBookingReducer,
    [Keys.PHONE_ENTRY_ROOT_KEY]: phoneEntryPageReducer,
    [Keys.REVIEW_AND_BOOK_ROOT_KEY]: reviewAndBookPageReducer,
    [Keys.WELL_GUIDE_ROOT_KEY]: wellGuideReducer,
    [Keys.SIGN_UP_KEY]: signupReducer,
    [Keys.SURVEY_ROOT_KEY]: surveyReducer,
    [TIMESGRID_ROOT_KEY]: timesgridReducer,
    [Keys.RESET_PASSWORD_ROOT_KEY]: resetPassword,
};
